import React from 'react';
import { products } from '../mockData';
import { Check } from 'lucide-react';

const Products = () => {
  return (
    <div className="page-container">
      {/* Page Header */}
      <section className="page-header">
        <h1 className="page-title">Our Products</h1>
        <p className="page-subtitle">
          Innovative software products designed to streamline your business operations
        </p>
      </section>

      {/* Products Grid */}
      <section className="products-section">
        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image-container">
                <img src={product.image} alt={product.name} className="product-image" />
              </div>
              <div className="product-content">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                <div className="product-features">
                  {product.features.map((feature, index) => (
                    <div key={index} className="product-feature">
                      <Check className="product-feature-icon" size={16} />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
                <button className="btn-product">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Custom Solutions */}
      <section className="custom-solutions">
        <h2 className="section-title">Need a Custom Solution?</h2>
        <p className="section-subtitle">
          We specialize in building tailored software products that match your unique business requirements.
        </p>
        <button className="btn-primary">Request a Consultation</button>
      </section>
    </div>
  );
};

export default Products;
